import { defineMessages } from 'react-intl'

export default defineMessages({
  markAsPaid: {
    id: 'containers.OrderPage.components.TaskPage.components.MarkAsPaidMenuItem.title',
    defaultMessage: 'Mark as paid',
  },
  markAsNotPaid: {
    id: 'containers.OrderPage.components.TaskPage.components.MarkAsPaidMenuItem.markAsNotPaid',
    defaultMessage: 'Mark as not paid',
  },
  confirmMarkAsPaidPrompt: {
    id: 'containers.OrderPage.components.TaskPage.components.MarkAsPaidMenuItem.confirmMarkAsPaidPrompt',
    defaultMessage: 'Are you sure you want to mark this task as paid?',
  },
  confirmMarkAsNotPaidPrompt: {
    id: 'containers.OrderPage.components.TaskPage.components.MarkAsPaidMenuItem.confirmMarkAsNotPaidPrompt',
    defaultMessage: 'Are you sure you want to mark this task as not paid?',
  }
})
